var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 4h23.042v16.661H.5z",
    fill: "#335280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 16.146l5.765-5.765 5.766 5.765-5.766 5.765z",
    fill: "#CCA000"
  })));
}
export default SvgCertificates;